/* Eligibility uses presentment cents and the selected purchase allocation. */
(() => {
  if (customElements.get('beleaev-free-shipping')) return;
  class FreeShipping extends HTMLElement {
    connectedCallback() {
      queueMicrotask(() => {
        if (!this.isConnected || this.abort) return;
        try { this.data = JSON.parse(this.querySelector('script').textContent); } catch (_) { return; }
        const productRoot = this.closest('product-info, [id^="ProductInfo-"]');
        const card = this.closest('.card-wrapper');
        this.card = card && (!productRoot || productRoot.contains(card)) ? card : null;
        this.root = this.card || productRoot;
        if (!this.root) return;
        this.abort = new AbortController();
        ['change', 'input', 'beleaev:display-price-change', 'beleaev:purchase-change', 'beleaev:purchase-state-sync'].forEach(name =>
          this.root.addEventListener(name, () => this.schedule(), { capture: true, signal: this.abort.signal }));
        this.observer = new MutationObserver(() => this.schedule());
        this.observer.observe(this.root, { childList: true, subtree: true, attributes: true, attributeFilter: ['value', 'checked', 'disabled', 'hidden', 'class', 'data-unit-cents'] });
        this.update();
      });
    }
    disconnectedCallback() { this.abort?.abort(); this.observer?.disconnect(); cancelAnimationFrame(this.frame); this.abort = null; }
    schedule() { if (!this.frame) this.frame = requestAnimationFrame(() => { this.frame = 0; if (this.isConnected) this.update(); }); }
    update() {
      let price = null;
      let shipping = false;
      const d = this.data;
      if (d.country === 'GB' && d.currency === 'GBP') {
        const form = !this.card && Array.from(this.root.querySelectorAll('form')).find(f => f.getAttribute('id') === d.formId);
        const id = this.card ? this.card.dataset.blvQuickAddVariantId : form?.querySelector('[name="id"]')?.value;
        const effective = v => v.merchantPrice > 0 ? v.merchantPrice : v.price;
        const variant = this.card && !id
          ? d.variants.reduce((best, v) => !best || effective(v) < effective(best) ? v : best, null)
          : d.variants.find(v => String(v.id) === String(id));
        if (variant) {
          shipping = variant.shipping;
          price = effective(variant);
          const plan = form && Array.from(form.querySelectorAll('[name="selling_plan"]')).find(e => !e.disabled && e.value)?.value;
          if (plan) price = variant.plans.find(p => String(p.id) === String(plan))?.price ?? null;
          else {
            const offer = window.BeleaevWagyuLaunch?.active && window.BeleaevWagyuLaunch.offers?.find(o => o.handles.includes(d.handle));
            if (offer && !(variant.merchantPrice > 0)) price = Math.round(price * (100 - Number(offer.discount)) / 100);
            const merchant = this.root.querySelector('.variant-input:checked + .variant-label .variant-price')?.getAttribute('data-merchant-sale-cents');
            if (!this.card && merchant !== null && merchant !== undefined) price = Number(merchant);
          }
          const allocation = this.card ? null : this.root.querySelector('beleaev-subscription-prices:not([hidden])');
          if (allocation?.dataset.currency === 'GBP' && allocation.dataset.unitCents) price = Number(allocation.dataset.unitCents);
        }
      }
      const hide = !(shipping && Number.isSafeInteger(price) && price > 20000);
      if (this.hidden !== hide) this.hidden = hide;
    }
  }
  customElements.define('beleaev-free-shipping', FreeShipping);
})();